import React from 'react';
import { Link } from 'gatsby';
import Img from 'shared/img';
import s from './person.module.scss';

function PersonCard({ name, lastname, username, image, small }) {
  return (
    <Link
      to={['/influencers', username?.replace(/@/gmi, '')].join('/')}
      className={s.container}
    >
      <div className={s.imgWrapper}>
        <Img
          effect
          src={image?.id || 'placeholder-dark'}
          className={`${s.img} ${small ? s.small : ''}`}
          alt={`${name} ${lastname} profile picture`}
      />
      </div>

      <div className={s.infoWrapper}>
        <div className={`${s.name} ${small ? s.small : ''}`}>
          {`${name} ${lastname || ''}`}
        </div>
        <div className={`${s.location} ${small ? s.small : ''}`}>
          {`${username && username.includes('@') ? '' : '@'}${username}`}
        </div>
      </div>
    </Link>
  );
}
export default PersonCard;
